/* 店铺管理 */
import { GET, PUT, DELETE, POST } from '@/request/http'
export const test = p => GET('/store/stores/{a}', p, 1)
export const test2 = p => PUT('/store/stores/{b}', p, 2)
export const test3 = p => DELETE('/store/stores/{c}', p, 3)
export const test4 = p => POST('/store/stores/{a}/{b}', p)



// WEBPACK FOOTER //
// ./src/api/modules/test.js